"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

var _reactScroll = require("react-scroll");

var _reactHighlightWords = _interopRequireDefault(require("react-highlight-words"));

var _Text = require("./Text.style");

var _helper = require("../../lib/utils/helper");

var Text = function Text(_ref) {
  var children = _ref.children;

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var resetSearchParmas = function resetSearchParmas() {
    var currentParams = {};

    var _iterator = (0, _createForOfIteratorHelper2.default)(searchParams.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        currentParams[entry[0]] = entry[1];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    setSearchParams((0, _objectSpread2.default)((0, _objectSpread2.default)({}, currentParams), {}, {
      search: '',
      rowId: '',
      rowIds: ''
    }));
    setSearch('');
  };

  (0, _react.useEffect)(function () {
    var _searchParams = _queryString.default.parse(searchParams.toString());

    var searchStr = _searchParams.search || '';
    var rowIds = (0, _helper.tryParseJson)(_searchParams.rowIds);

    if (searchStr) {
      setSearch(searchStr);
    }

    if (rowIds !== null && rowIds !== void 0 && rowIds.length && rowIds.includes((0, _helper.normalizeString)(children))) {
      setSearch(children);
    }
  }, [searchParams, search]);
  return /*#__PURE__*/_react.default.createElement(_reactScroll.Element, {
    key: (0, _helper.generateRowId)(children),
    name: (0, _helper.generateRowId)(children)
  }, /*#__PURE__*/_react.default.createElement(_Text.TextWrapper, {
    onClick: function onClick() {
      return resetSearchParmas();
    }
  }, /*#__PURE__*/_react.default.createElement(_reactHighlightWords.default, {
    highlightClassName: "highlighted",
    searchWords: [search],
    autoEscape: true,
    textToHighlight: children
  })));
};

exports.Text = Text;